(ns app.workspace-settings.views
  (:require
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [app.routes :as routes]
   [re-com.core :as re-com :refer [at h-box box  v-box modal-panel]]
   [app.styles :refer [app-bar new-workspace-container create-workspace-title create-workspace-space]]
   [app.events :as events]
   [app.new-workspace.events :as wevents]
   [app.new-workspace.subs :as wsubs]
   [app.subs :as subs]
   [app.dashboard.events :as devents]
   [reagent.core  :as reagent :refer [atom]]
   [app.components.buttons.views :as buttons]
   [app.components.headers.views :refer [header]]
   [app.workspace-settings.styles :refer [settings-card settings-panel]]
   [app.components.input-field.views :refer [input-field]]
   [app.pusher :as pusher]))


(defn template-header []
  [v-box
   :src (at)
   :gap "8px"
   :children [[header {:label "Workspace Settings" :type :title :size :large}]]])


(defn settings-card-view [item-input-id item-input-value]
  (let [text-val (reagent/atom item-input-value)
        settings-clicked? (reagent/atom false)]
    (fn
      []
      [v-box
       :src (at)
       :gap "17px"
       :class (settings-card)
       :children (into [[header {:label "Rename this workspace" :type :large :size :semibold}]]
                       (if @settings-clicked?
                         [[input-field {:placeholder "" :disable false :value text-val
                                        :onChange #(reset! text-val %)
                                        :width "448px"}]
                          [h-box
                           :gap "15px"
                           :children [[buttons/button {:action :cta :type :secondary
                                                       :title "cancel"
                                                       :size :medium :onClick   #(reset! settings-clicked? false)}]
                                      [buttons/button {:action :cta :type :primary
                                                       :title "save"
                                                       :size :medium :onClick  #(do
                                                                                  (re-posh/dispatch [::wevents/update-workspace-name {:workspace-id item-input-id :name @text-val}])
                                                                                  (reset! settings-clicked? false))}]]]]
                         [[header {:label "Change the name of workspace" :type :large :size :regular}]
                          [box :width "189px" :child [buttons/button {:action :cta :type :primary
                                                                      :title "Rename Workspace"
                                                                      :size :medium :onClick  #(reset! settings-clicked? true)}]]]))])))

(defn icon-settings-card-view [workspace-id]
  [v-box
   :src (at)
   :gap "17px"
   :class (settings-card)
   :children [[header {:label "Workspace icon" :type :large :size :semibold}]
              [header {:label "Add an icon to make it easier to identify your workspace." :type :large :size :regular}]
              [:div
               {:style {:position "relative"
                        :overflow "hidden"
                        :cursor "pointer"
                        :display "inline-block"}}
               [:input {:style {:font-size "100px"
                                :position "absolute"
                                :left 0
                                :top 0
                                :opacity 0}
                        :type "file"
                        :name "file"
                        :id "contained-button-file"
                        :accept "image/*"
                        :multipe true
                        :onChange (fn [^js/Event ev]
                                    (let [form-data (js/FormData.)]
                                      (.append form-data "file" (first (-> ev .-target.files)))
                                      (re-posh/dispatch [::wevents/upload-image {:workspace-id workspace-id :file form-data}])))}]
               [:label {:htmlFor "contained-button-file"}
                [buttons/button {:action :cta :type :primary
                                 :title "Upload icon"
                                 :size :medium :onClick  #(println "TETS")
                                 :attr {:htmlFor "contained-button-file"}}]]]]])





(defn dialog-markup
  [workspace-id  item-input-value show-dialog?]
  (let [text-val (reagent/atom nil)]
    (fn []
      [v-box :src (at)
       :padding  "8px"
       :gap "16px"
       :justify :center
       :align :center
       :width "408px"
       :children [[header {:label "Deleting this workspace will also delete all the content within it.
                                 You will not be able to restore it afterwords." :type :small :size :semibold
                           :style {:text-align "center"}}]
                  [header {:label "To confirm, please enter the workspace name" :type :small :size :semibold}]
                  [input-field {:placeholder "" :disable false :value text-val
                                :onChange #(reset! text-val %)
                                :width "366px"}]
                  [h-box :src (at)
                   :gap      "8px"
                   :children [[buttons/button {:action :cta :type :secondary
                                               :title "Keep Workspace"
                                               :size :large
                                               :onClick #(reset! show-dialog? false)}]
                              [buttons/button {:action :warning :type :primary
                                               :title "Delete Workspace"
                                               :size :large
                                               :onClick #((when (= @text-val item-input-value)

                                                            (re-posh/dispatch [::wevents/delete-workspace workspace-id]))
                                                          (reset! show-dialog? false))}]]]]])))

(defn delete-settings-card-view [item-input-id item-input-value]
  (let [show-dialog? (reagent/atom false)]
    (fn []
      [v-box
       :src (at)
       :gap "17px"
       :class (settings-card)
       :children [[header {:label "Delete workspace" :type :large :size :semibold}]
                  [header {:label "Careful! This can not be undone." :type :large :size :regular}]
                  [box :width "189px" :child [buttons/button {:action :warning :type :primary
                                                              :title "Delete Workspace"
                                                              :size :medium
                                                              :onClick   #(reset! show-dialog? true)}]]
                  (when @show-dialog? [modal-panel :src (at)
                                       :backdrop-color   "grey"
                                       :backdrop-opacity 0.4
                                       :child            [dialog-markup item-input-id item-input-value show-dialog?]])]])))
(defn workspace-settings-panel []
  (reagent/create-class
   {:reagent-render
    (fn [] (let [{item-input-id :selected-workspace/id
                  item-input-value :selected-workspace/name} @(re-posh/subscribe [::subs/selected-workspace-data])]
             [v-box
              :src      (at)
              :height "calc(100% - 56px)"
              :size "auto"
              :gap "22px"
              :class (settings-panel)
              :children [[template-header]
                         [icon-settings-card-view item-input-id]
                         [settings-card-view  item-input-id  item-input-value]
                         [delete-settings-card-view item-input-id item-input-value]]]))}))

(defmethod routes/panels :workspace-settings-panel [] [workspace-settings-panel])